import Toast2 from "@/components/Toast2";
import { assetUrl } from '@/utils/asset-url';
import useApprovalsPage from "@/hooks/use-approvals/index";
import usePage from "@/hooks/use-page";
import "@/translations/i18n";
import { useState } from "react";
import ReactDOM from 'react-dom';
import { DataTable } from "./approvals-data-table";
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";

const Page = () => {
	/*=================================================
		General
	/================================================*/

	const pageTitle = "Approvals";
	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: '/'
			 },
			{
				label: 'Approvals',
				link: ''
			}
		]
	});


	/*=================================================
		Pagination
	/================================================*/

	const [currentPage, setCurrentPage] = useState(1);
	const pageLimit = 10;

	/*=================================================
		Fetch Approvals
	/================================================*/


	const { meta: approvalsMeta, itemsData, fetchApprovals: fetchApprovalsData, sortConfig, setSortConfig, loading } = useApprovalsPage();


	/*=================================================
		Error Modal
	/================================================*/


	const [error, setError] = useState();
	function handleError() {
		setError();
	}


	/*================================================
		List of Approval Data
	/================================================*/


	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
			<div className="title-header" style={{ paddingBottom: 0 }}>
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>
			</div>

			{/* ====== Data Table ======  */}

			<div className="overview__content">
				{
					<DataTable
						itemsData={itemsData}
						pageLimit={pageLimit}
						currentPage={currentPage}
						fetchApprovalsData={fetchApprovalsData}
						approvalsMeta={approvalsMeta}
						setCurrentPage={setCurrentPage}
						loading={loading}
						sortConfig={sortConfig}
						setSortConfig={setSortConfig}
					/>
				}
			</div>

			{/* ====== Data Table ======  */}

			<Toast2
				show={error}
				errorMessage={error}
				close={() => {
					handleError();
				}}
				data-testid="error-toast-close-button"
			/>

			{
				loading && (
					ReactDOM.createPortal(
						<div className='modal white' data-testid="loading-spinner">
							<div className='loading'>
								<img src={assetUrl("/loading.gif")} />
							</div>
						</div>
						, document.body
					)
				)
			}
		</>
	);
};
export default Page;
